export const initialState = () => {
	return {
		openSections: [],
		activeTab:    null,
	};
};

export const mutations = {
	openSection(state, section) {
		state.openSections = [...state.openSections.filter(s => s !== section), section];
	},
	closeSection(state, section) {
		state.openSections = state.openSections.filter(s => s !== section);
	},
	setActiveTab(state, tab) {
		state.activeTab = tab;
	},
};

export const actions = {
	init({ commit, getters }) {
		// all sections are open initially
		Object.keys(getters.enabledSections).forEach(section => {
			if (getters.enabledSections[section]) {
				commit('openSection', section);
			}
		});
	},
	toggleSection({ commit, getters }, section) {
		if (getters.openSections[section]) {
			commit('closeSection', section);
		} else {
			commit('openSection', section);
		}
	},
	setActiveTab({ commit }, tab) {
		commit('setActiveTab', tab);
	},
};

export const getters = {
	isOpen:       (state) => (section) => state.openSections.includes(section),
	openSections: (state, getters) => {
		return Object.keys(getters.enabledSections).reduce((acc, section) => {
			return {
				...acc,
				[section]: state.openSections.includes(section) && getters.allowedSections[section],
			};
		}, {});
	},
	/**
	 * @return { Object } - object with enabled status per section,
	 *                      eg: { default: true, additional: true, match: false, ....}
	 */
	enabledSections: (state, getters, rootState, rootGetters) => {
		const selectedGroup = rootGetters['tagGroups/selectedTagGroup'];
		return rootGetters['tagGroups/tagGroupSectionStatuses'](selectedGroup);
	},
	allowedSections: (state, getters, rootState, rootGetters) => {
		return Object.keys(getters.enabledSections).reduce((acc, section) => {
			return {
				...acc,
				[section]: rootGetters['permissions/canViewTagGroupSection'](section),
			};
		}, {});
	},
	defaultButtons: (state, getters, rootState, rootGetters) => {
		const defaultGroup = rootGetters['tagGroups/defaultTagGroup'];
		return [...defaultGroup.defaultButtons];
	},
	additionalParticipantButtons: (state, getters, rootState, rootGetters) => {
		const defaultGroup = rootGetters['tagGroups/defaultTagGroup'];
		return [...defaultGroup.additionalParticipantButtons];
	},
	activeTab: (state) => state.activeTab,
};

export const tagCenter = {
	namespaced: true,
	state:      initialState(),
	actions,
	mutations,
	getters,
};

export default tagCenter;
